Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconViewData: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24.1 24.1' width='24' height='24'%3e%3cg data-name='Icon-/-24x24-/-view'%3e%3cpath data-name='%f0%9f%8e%a8-Color' d='M11.94 4.05a12.09 12.09 0 0111.15 7.63l.14.36-.13.36a11.71 11.71 0 01-11.16 7.65A11.45 11.45 0 011 12.4L.87 12l.13-.32a11.78 11.78 0 0110.94-7.63zm0 14a9.71 9.71 0 009.14-6 10.08 10.08 0 00-9.14-6 9.74 9.74 0 00-8.92 6 9.41 9.41 0 008.92 6zm0-2a4 4 0 114-4 4 4 0 01-4 4zm0-2a2 2 0 10-2-2 2 2 0 002 2z' fill='currentColor'/%3e%3c/g%3e%3c/svg%3e",
  iconViewWidth: 24,
  iconViewHeight: 24
};